import React from 'react';
import { Box, Divider } from '@mui/material';

const NotFound: React.FC = () => {
  return (
    <Box sx={{ m: 2 }}>
      <h3>お探しのページは見つかりませんでした。</h3>
      <Divider sx={{ marginY: 1 }} />
      <i>ま、ごゆっくりな。</i>
    </Box>
  );
};

export default NotFound;
